module.exports = __webpack_public_path__ + "static/media/home-wood-2@2x.33b3934c.jpg";